export default __webpack_public_path__ + "static/media/icon_delete.a886f0fc.svg";